import React, { FC, useEffect, useRef, useState } from "react";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";

import styles from "./CreateDocument.module.sass";
import { snackWrapper } from "helpers";

interface AddDocumentProps {
	nextStep: () => void;
	setFile: (file: File) => void;
}

const AddDocument: FC<AddDocumentProps> = ({ nextStep, setFile }) => {
	const inputRef = useRef<HTMLInputElement | null>(null);
	const [document, setDocument] = useState<any>(null);
	const documentHandler = (file: File) => {
		setDocument(file);
		setFile(file);
	};
	const dragEnterHandler = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const dragLeaveHandler = (e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		e.stopPropagation();
	};

	const handleDrop = (e: React.DragEvent) => {
		e.preventDefault();
		let dt = e.dataTransfer;
		let files = dt.files;
		const file = files[0];
		if (/\.docx?$/.test(file.name)) {
			documentHandler(file);
		} else {
			snackWrapper("warn", "Не поддерживается формат\nНеобходимый формат .docx");
		}
	};

	const changeInputHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
		const { files } = e.currentTarget;
		const file = files ? files[0] : false;
		if (file) {
			documentHandler(file);
			setFile(file);
		}
		e.currentTarget.value = "";
		e.currentTarget.files = null;
	};

	useEffect(() => {
		if (document) {
			nextStep();
		}
		//eslint-disable-next-line
	}, [document]);

	return (
		<div onDragOver={dragEnterHandler} onDragLeave={dragLeaveHandler} onDrop={handleDrop} className={styles.border}>
			<input
				accept={"application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword"}
				type="file"
				ref={inputRef}
				hidden={true}
				onChange={changeInputHandler}
			/>
			<div className={styles.infoText}>Перетащите документ в это окно или</div>
			<Button onClick={() => inputRef.current && inputRef.current?.click()} variant={BUTTON_VARIANTS.OUTLINED}>
				Выберите документ на компьютере
			</Button>
		</div>
	);
};

export default AddDocument;
